<template>
  <v-app>

    <v-slide-y-transition mode="out-in">

      <template v-if="!$route.meta.public && $auth.check()">
        <app-boot>
          <layout-principal v-if="!$route.meta.fullscreen"></layout-principal>
          
          <template v-else>
            <transition>
              <keep-alive>
              <router-view></router-view>
              </keep-alive>
            </transition>
          </template>

        </app-boot>
      </template>

      <template v-else>
        <transition>
          <keep-alive>
          <router-view></router-view>
          </keep-alive>
        </transition>
      </template>

    </v-slide-y-transition>

    <v-snackbar outlined bottom center vertical :value="updateExists" :timeout="-1" color="primary">
      Uma atualização está disponível.
      <template v-slot:action>
        <v-btn small color="primary" @click="refreshApp">
          Atualizar Agora
        </v-btn>
      </template>
    </v-snackbar>
    

    <z-toast ref="toast"></z-toast>
  </v-app>
</template>

<script>
import LayoutPrincipal from "@/pages/layout/AppLayout.vue";
import LayoutPrincipal2 from "@/pages/layout/AppLayout2.vue";

import update from '@/app/mixins/update';

export default {
  name: "App",
  components: {
    LayoutPrincipal,
    LayoutPrincipal2,
  },

  mixins: [update],

  data() {
    return {};
  },

  // created() {
  //   this.$axios.interceptors.response.use(undefined, function (err) {
  //     return new Promise(function (resolve, reject) {
  //       if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
  //         this.$auth.logout();
  //         this.$router.push('/login');
  //       }
  //       throw err;
  //     });
  //   });
  // },

  mounted() {
    // if (this.$auth.check()) {
    //   console.log('Está logado');
    // } else {
    //   console.log('NÃO está logado');
    // }
  },

  provide() {
    return {
      toast: this.toast(),
    };
  },

  methods: {
    toast() {
      const vm = this;
      return {
        notificar(mensagem, timeout = 3) {
          vm.$refs.toast.exibir({
            mensagem: mensagem,
            timeout: timeout * 1000,
          });
        },
        error(mensagem, erro=null, timeout = 3) {
          const mensagemErro = erro ? '<br> Erro: ' + erro : "";
          vm.$refs.toast.exibir({
            mensagem: mensagem + mensagemErro,
            cor: "error",
            timeout: timeout * 1000,
          });
        },
      }
    }
  },
};
</script>

<style>

  .x-small {
      font-size: 11px;
      height: 18px;
  }

</style>
